<template>
  <div class="MAIN">
    <headerVisualization></headerVisualization>
    <div class="contain"
      :style="{ backgroundImage: 'url(' + srcImgUrl + ')', backgroundRepeat: 'no-repeat', 'background-size': 'cover' }">
      <div class="MidTop">
        <div class="status-indicator online">
          <div class="indicator-dot"></div>
          <span class="indicator-text">在线：{{ alarme.onLineNum }}</span>
        </div>
        <div class="status-indicator alarm">
          <div class="indicator-dot"></div>
          <span class="indicator-text">报警：{{ alarme.alarmNum }}</span>
        </div>
      </div>
      <div class="leftContain">
        <!-- 左边总览 -->
        <OverviewIndicators></OverviewIndicators>
        <BulletinBoard></BulletinBoard>
      </div>
      <div class="midContain">
        <div class="mapWarp">
          <div class="mapLine" style="left:0"></div>
          <blue-map style="width:100%; height:680px"></blue-map>
          <div class="mapLine" style="right: 0;"></div>
        </div>
        <FlowMonitoring></FlowMonitoring>
      </div>

      <div class="rightContain">
        <WaterSupply></WaterSupply>
        <div class="rightContain-secend">
          <div class="secend-left">
            <!-- 维修指标 -->
            <MaintenanceIndex></MaintenanceIndex>
            <leakageRanking></leakageRanking>
          </div>
          <div class="secend-right">
            <RevenueMonitoring></RevenueMonitoring>
            <WaterMonitoring></WaterMonitoring>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerVisualization from './modules/headerVisualization'
import OverviewIndicators from './modules/OverviewIndicators'
import BulletinBoard from './modules/BulletinBoard'
import FlowMonitoring from './modules/FlowMonitoring'
import WaterSupply from './modules/WaterSupply'
import MaintenanceIndex from './modules/MaintenanceIndex'
import RevenueMonitoring from './modules/RevenueMonitoring'
import leakageRanking from './modules/leakageRanking'
import WaterMonitoring from './modules/WaterMonitoring'
import blueMap from './modules/blueMap'

export default {
  name: 'DataVisualization',
  components: {
    headerVisualization,
    OverviewIndicators,
    BulletinBoard,
    FlowMonitoring,
    WaterSupply,
    MaintenanceIndex,
    RevenueMonitoring,
    leakageRanking,
    WaterMonitoring,
    blueMap
  },
  data () {
    return {
      srcImgUrl: '/bg.png',
      alarme: {
        alarmNum: '',
        onLineNum: '',
        piezometerNum: ''
      }
    }
  },
  created () {
    this.getBackground()
    this.getOnlineAlarme()
  },
  methods: {
    getOnlineAlarme () {
      this.$http.get('/pipe-network/piezometer/analysis/online/alarme').then(res => {
        this.alarme = res.data

      })
    },
    getBackground () {
      this.$http.get('/manager/tenants/large-screen/image').then(res => {
        // eslint-disable-next-line no-unused-expressions
        res.data.configValue ? (this.srcImgUrl = res.data.configValue) : ''
      })
    }
  }
}
</script>

<style lang="less" scoped>
.MAIN {
  width: 100vw;
  max-width: 100%;
  min-height: 100vh;
  background-color: rgb(0, 25, 46);

  .contain {
    z-index: 1;
    // height: calc(100vh - 58px);
    padding: 14px;
    padding-bottom: 26px;
    padding-top: 42px;
    height: 100%;
    width: 100vw;
    max-width: 100%;
    display: flex;
    justify-content: space-between;
// position: relative;
  .MidTop {
    position: absolute;
    left: 450px;
    display: flex;
    flex-direction: row;
    z-index: 1000;
    gap: 1rem;
    padding: 0.5rem;

    .status-indicator {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem 1rem;
      
      border-radius: 4px;
      font-size: 16px;
      font-family: MicrosoftYaHeiSemibold;
      font-weight: 600;
      background: rgba(0, 0, 0, 0.3);

      .indicator-dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
      }

      .indicator-text {
        color: inherit;
      }
    }

    .online {
      border: 1px solid #00ebee;
      color: #00ebee;

      .indicator-dot {
        background: #00ebee;
      }
    }

    .alarm {
      border: 1px solid #CA2E2E;
      color: #CA2E2E;

      .indicator-dot {
        background: #CA2E2E;
      }
    }
  }

  .leftContain {      //   background: red;
      // height: calc(100vh - 58px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 954px;
      width: 408px;
    }

    .midContain {
      .mapWarp {
        height: 680px;
        padding: 0px;
        width: 100%;
        background: rgba(4, 8, 40, 0.75);
        // border: 1px solid #2f7ba3;
        opacity: 0.8;
        box-shadow: inset 0 0 46px 0 rgba(60, 162, 255, 0.39);
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        // border-radius: 12px;
        position: relative;
        margin-bottom: 24px;

        .mapLine {
          position: absolute;
          // left: 0;
          z-index: 1000;
          width: 3px;
          height: 675px;
          background: url(~@/assets/myImg/1/line.png) no-repeat;
          background-size: contain;
        }
      }

      height: 954px;
      align-self: flex-end;
      width: calc(100vw - 1282px);
      margin-left: 24px;
      margin-right: 24px;
    }

    .rightContain {
      //   background: pink;
      // height: calc(100vh - 58px);
      height: 954px;
      width: 776px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .rightContain-secend {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .secend-left {
          height: 674px;
          width: 376px;
          padding-top: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .secend-right {
          height: 674px;
          width: 376px;
          padding-top: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
